import "../styles/index.less";
import { Button, Typography, Row, Col, Divider } from "antd";
import { TrophyOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import User1 from "../../../assets/images/icons/user1.png";
import User2 from "../../../assets/images/icons/user2.png";
import User3 from "../../../assets/images/icons/user3.png";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";
import { useEffect, useState } from "react";


const { Title } = Typography;

type Props = {};

const ConLeader = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [forceUpdate, setForceUpdate] = useState(false);

  useEffect(() => {
    setForceUpdate((prev) => !prev); // บังคับให้ re-render
  }, [i18n.language]);

  return (
    <div className="globalcontainer">
      <div className="task-section">
        <div className="section-title" data-aos="fade-up">
          <Divider
            className="dividline"
            style={{ backgroundColor: "#363636" }}
          />
        </div>
      </div>

      <div className="leaderboard-section">
        <Row
          // gutter={[16 , 16]}
          justify="center"
          align="middle"
          style={{ height: "100%" , padding:"0px 20px" }}
        >
          <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{marginBottom:30}}>
            <Row align={"bottom"}>
              <Col xs={8} sm={8} md={8} lg={8} style={{ marginRight: "-40px", zIndex: 0 }}>
                <div>
                  <Row justify={"center"}>
                    <Title>2</Title>
                  </Row>
                  <Row justify={"center"}>
                    <img src={User2} width="100%" style={{ maxWidth: "180px" }} alt="rank 2" />
                  </Row>
                </div>
              </Col>
              <Col xs={9} sm={9} md={9} lg={9} style={{ zIndex: 1 }} >
                <div>
                  <Row justify={"center"}>
                    <Title>1</Title>
                  </Row>
                  <Row justify={"center"}>
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/2385/2385865.png"
                      width={80}
                      height={80}
                      alt="crown"
                    />
                  </Row>
                  <Row justify={"center"}>
                    <img src={User1} width="100%" style={{ maxWidth: "250px" }} alt="rank 1" />
                  </Row>
                </div>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} style={{ marginLeft: "-40px", zIndex: 0 }} >
                <div>
                  <Row justify={"center"}>
                    <Title>3</Title>
                  </Row>
                  <Row justify={"center"}>
                    <img src={User3} width="100%" style={{ maxWidth: "180px" }} alt="rank 3" />
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>



          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div className="leaderboard-title">
              <span className="red-bar"></span>
              <p
                className="detail-title-leader"
                style={{
                  textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  marginBottom: "0px",
                  fontFamily: "IBM Plex Sans Thai",
                  color: "#052240",
                }}
              >
                {t("Leaderboard")}
              </p>
            </div>
            <div className="leaderboard-description">
              <p
                className="detailtask-leader"
                style={{
                  color: "#363636",
                  fontFamily: "IBM Plex Sans Thai",
                  lineHeight:"35px"
                }}
              >
                {t("LeaderboardHome")}
              </p>
            </div>
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                size="large"
                className="btnleadmain"
                style={{
                  marginTop: "20px",
                  backgroundColor: "#052240",
                  borderColor: "#052240",
                  fontSize: "18px",
                  width: "100%",
                  maxWidth: "250px",
                  height: "auto",
                  borderRadius: "20px",
                  padding: "10px",
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/task`);
                }}
              >
                {t("All Leaderboard")}
                <TrophyOutlined
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#BC224A",
                    padding: "5px",
                    borderRadius: "25px",
                  }}
                />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ConLeader;
